import React from 'react';
import { cardStyle as styles } from './howItWorks.tailwind';

const OverlayComponent = ({ data }) => {
  return (
    <div className={styles.card_wrpr}
      style={{
        backgroundImage: `url(${data?.image})`,
      }}
    >
      {/* Hovered-overlay-blurred */}
      <div className={styles.overlay_screen} />
      {/* Default-overlay */}
      <div className={styles.overlay_screen_default} />

      {/* Centered Text - Transition on hover */}
      <div className={styles.text_wrpr}>
        {/* Primary Text - Positioned at the bottom by default */}
        <h1 className={styles.heading}>{data?.heading}</h1>

        {/* Additional Text - Initially hidden and positioned below */}
        <p className={styles.description}>“{data?.description}”</p>
      </div>
    </div>
  );
};

export default OverlayComponent;
